module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.forgot) ? _c('div', {
    key: "authenticate",
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.username,
      "error": _vm.wrgUser,
      "type": "text",
      "placeholder": _vm.$t('login.username')
    },
    on: {
      "input": function($event) {
        _vm.username = $event;
        _vm.wrgUser = false
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.password,
      "error": _vm.wrgPass,
      "type": "password",
      "placeholder": _vm.$t('login.password')
    },
    on: {
      "input": function($event) {
        _vm.password = $event;
        _vm.wrgPass = false
      },
      "enter": function($event) {
        _vm.authenticate()
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "form-group"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.forgot = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('login.forgot')) + "\n          ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-kne-orange col-12",
    on: {
      "click": function($event) {
        _vm.authenticate()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('login.submit')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.forgot) ? _c('div', {
    key: "forgot",
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.username,
      "error": _vm.wrgUser,
      "success": _vm.emailSent,
      "type": "text",
      "placeholder": _vm.$t('login.username')
    },
    on: {
      "input": function($event) {
        _vm.username = $event;
        _vm.wrgUser = false
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "form-group"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.forgot = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('login.authenticate')) + "\n          ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-kne-orange col-12",
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('login.reset')) + "\n        ")])]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/KeepNeye.png"),
      "width": "100",
      "height": "100",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-471518be","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Login.vue
// module id = 836
// module chunks = 1